import { SyncContextType } from 'app/modules/settings/domain/valueObject/SyncContextType';
import { SyncStatus } from 'app/modules/settings/domain/valueObject/SyncStatus';

export class SpecificSyncStatus {

    private readonly _id: string;
    private readonly _contextType: SyncContextType;
    private readonly _contextId: string;
    private readonly _name: string;
    private readonly _status: SyncStatus;
    private readonly _startedAt: Date | null;
    private readonly _finishedAt: Date | null;
    private readonly _pendingCount: number;

    public constructor(
        id: string,
        contextType: SyncContextType,
        contextId: string,
        name: string,
        status: SyncStatus,
        startedAt: Date | null,
        finishedAt: Date | null,
        pendingCount: number,
    ) {
        this._id = id;
        this._contextType = contextType;
        this._contextId = contextId;
        this._name = name;
        this._status = status;
        this._startedAt = startedAt;
        this._finishedAt = finishedAt;
        this._pendingCount = pendingCount;
    }

    public get id(): string {
        return this._id;
    }

    public get contextType(): SyncContextType {
        return this._contextType;
    }

    public get contextId(): string {
        return this._contextId;
    }

    public get name(): string {
        return this._name;
    }

    public get status(): SyncStatus {
        return this._status;
    }

    public get startedAt(): Date | null {
        return this._startedAt;
    }

    public get finishedAt(): Date | null {
        return this._finishedAt;
    }

    public get pendingCount(): number {
        return this._pendingCount;
    }

}
